document.addEventListener("DOMContentLoaded", function () {
  var wrap = document.getElementById("saol-quiz");
  if (!wrap) return;

  var scores = {
    women_fit: 0,
    men_power: 0,
    multi_v: 0,
    c_mix: 0,
    antioxidant: 0,
  };
  var answers = {};
  var current = 0;
  var totalSteps = 6;

  var ico = {
    battery:
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="16" height="10" rx="2"/><line x1="22" y1="11" x2="22" y2="13"/></svg>',
    sun: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>',
    check:
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
    zap: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    brain:
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a4 4 0 0 0-4 4c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2 4 4 0 0 0-4-4z"/><path d="M9 8v2a3 3 0 0 0 6 0V8"/><circle cx="12" cy="17" r="5"/></svg>',
    leaf: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.9C15.5 4.9 17 3.5 19 2c1 2 2 4.5 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>',
    shield:
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
    dumbbell:
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6.5 6.5 11 11"/><path d="m21 21-1-1"/><path d="m3 3 1 1"/><path d="m18 22 4-4"/><path d="m2 6 4-4"/><path d="m3 10 7-7"/><path d="m14 21 7-7"/></svg>',
    sofa: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0z"/><path d="M4 18v2"/><path d="M20 18v2"/></svg>',
    run: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 4h3a2 2 0 0 1 2 2v14"/><path d="M2 20h3"/><path d="M13 20h9"/><path d="M10 12v.01"/><path d="M13 4.562v16.157"/><path d="M16 4.28 6 20"/></svg>',
    monitor:
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>',
    lotus:
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z"/><path d="M12 6v12"/><path d="M8 8c2 2 2 4 0 6"/><path d="M16 8c-2 2-2 4 0 6"/></svg>',
    target:
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>',
    heart:
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    muscle:
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 2S2 6 2 12s4.5 10 4.5 10"/><path d="M17.5 2S22 6 22 12s-4.5 10-4.5 10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>',
    woman:
      '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M12 12c-3.314 0-6 1.343-6 3v3h12v-3c0-1.657-2.686-3-6-3z"/></svg>',
    man: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M12 12v8M12 20l-3-2M12 20l3-2"/></svg>',
  };

  var questions = [
    {
      q: "Cinsiyet?",
      opts: [
        { emoji: ico.woman, text: "Kadın", map: { women_fit: 2 } },
        { emoji: ico.man, text: "Erkek", map: { men_power: 2 } },
      ],
    },
    {
      q: "Bugün nasıl hissediyorsun?",
      opts: [
        {
          emoji: ico.battery,
          text: "Enerjim düşük",
          map: { men_power: 1, women_fit: 1, c_mix: 1 },
        },
        {
          emoji: ico.sun,
          text: "Normal ama daha iyi olabilir",
          map: { multi_v: 1, antioxidant: 1 },
        },
        { emoji: ico.check, text: "Gayet iyiyim", map: { antioxidant: 1 } },
      ],
    },
    {
      q: "Şu an en çok neye ihtiyacın var?",
      opts: [
        { emoji: ico.zap, text: "Enerji & performans", map: { men_power: 2 } },
        { emoji: ico.target, text: "Odak & denge", map: { women_fit: 2 } },
        {
          emoji: ico.leaf,
          text: "Hafiflik & temizlik",
          map: { antioxidant: 2 },
        },
        {
          emoji: ico.shield,
          text: "Bağışıklık için destek",
          map: { multi_v: 1, c_mix: 1 },
        },
      ],
    },
    {
      q: "Aktif olarak spor yapıyor musun?",
      opts: [
        {
          emoji: ico.dumbbell,
          text: "Evet",
          map: { men_power: 1, women_fit: 1 },
        },
        { emoji: ico.sofa, text: "Hayır", map: { antioxidant: 1, multi_v: 1 } },
      ],
    },
    {
      q: "Gününün çoğu nasıl geçiyor?",
      opts: [
        { emoji: ico.run, text: "Yoğun / aktif", map: { men_power: 1 } },
        {
          emoji: ico.monitor,
          text: "Masa başı",
          map: { women_fit: 1, c_mix: 1 },
        },
        { emoji: ico.lotus, text: "Daha sakin", map: { antioxidant: 1 } },
        { emoji: ico.target, text: "Karışık", map: { multi_v: 1 } },
      ],
    },
    {
      q: "Hangisi senin için daha önemli?",
      opts: [
        { emoji: ico.muscle, text: "Performans", map: { men_power: 2 } },
        { emoji: ico.heart, text: "Bağışıklık", map: { c_mix: 2 } },
        {
          emoji: ico.leaf,
          text: "Sindirim / hafiflik",
          map: { women_fit: 1, antioxidant: 1 },
        },
        {
          emoji: ico.zap,
          text: "Günlük destek",
          map: { antioxidant: 1, multi_v: 1 },
        },
      ],
    },
  ];

  var results = {
    women_fit: {
      emoji: ico.leaf,
      name: "WOMEN FIT",
      need: "Senin ihtiyacın: Denge",
      body: 'Gün içinde küçük iniş çıkışlar yaşıyorsun. Her şey yolunda gibi ama tam da değil.\n\nVücudun <strong>"beni biraz destekle ama yorma"</strong> diyor.\n\nWomen Fit, L-carnitine, prebiyotikler ve B vitaminleriyle seni zorlamadan destekler.',
      checks: ["Daha dengeli hissetmek", "Gün içinde hafif kalmak"],
      quote: "Bazen ihtiyacın olan şey daha fazla değil, daha doğru olandır.",
      handle: "women-fit",
      image: "saol-result-womenfit.png",
      bg: "#fce4ec",
      cardBg: "#f8bbd0",
    },
    men_power: {
      emoji: ico.zap,
      name: "MEN POWER",
      need: "Senin ihtiyacın: Boost",
      body: 'Gün hızlı. Sen daha hızlısın. Ama vücut bazen "bir dakika" diyor.\n\nMen Power, amino asitler, L-carnitine ve ginseng ile enerji üretimini destekler.\n\nYani sadece "uyan" değil, <strong>devam et</strong>.',
      checks: ["Enerji & performans", "Yoğun günlerde destek"],
      quote: "Kahve seni başlatır. Bu seni götürür.",
      handle: "men-power",
      image: "saol-result-menpower.png",
      bg: "#f5e6ea",
      cardBg: "#d4a0af",
    },
    multi_v: {
      emoji: ico.sun,
      name: "MULTI-V",
      need: "Senin ihtiyacın: Hepsinden Biraz",
      body: 'Spesifik bir problem yok ama "bir şey eksik" hissi var.\n\nİşte tam burası Multi-V.\n\nA, C, D, E vitaminleri + B kompleks + çinko → <strong>tek şişede geniş destek</strong>.',
      checks: ["Günlük vitamin ihtiyacı", "Dengeli destek"],
      quote:
        "Her şeyi ayrı ayrı düşünmek yerine, tek seferde çözmek isteyenlere.",
      handle: "multi-v",
      image: "saol-result-multiv.png",
      bg: "#fef0e0",
      cardBg: "#f5d0a0",
    },
    c_mix: {
      emoji: ico.shield,
      name: "C+MIX",
      need: "Senin ihtiyacın: Koruma",
      body: 'Sen önceden önlem alanlardansın. "Hasta olmadan halledelim" kafası.\n\nC+Mix, yüksek C vitamini + çinko ile bağışıklık sistemini destekler.\n\nGünlük ihtiyacının <strong>%100\'üne yakın C vitamini</strong>.',
      checks: ["Bağışıklık desteği", "Mevsim geçişleri"],
      quote: "Grip olunca değil, olmadan önce hatırlanır.",
      handle: "c-mix",
      image: "saol-result-cmix.png",
      bg: "#fdf8d8",
      cardBg: "#f7e76d",
    },
    antioxidant: {
      emoji: ico.check,
      name: "ANTIOXIDANT",
      need: "Senin ihtiyacın: Reset",
      body: "Bazen en iyisi durup hafiflemek. Vücudun da bunu söylüyor.\n\nAntioxidant, A, C, E vitaminleri ve çinko ile vücudu destekler ve dengeler.",
      checks: ["Günlük koruma", "Daha temiz his"],
      quote: "Detox yapmana gerek yok. Küçük bir reset yeter.",
      handle: "antioxidant",
      image: "saol-result-antioxidant.png",
      bg: "#e0f4f7",
      cardBg: "#a0d8e8",
    },
  };

  var otherCards = [
    { key: "women_fit", name: "Women Fit", bg: "#fce4ec" },
    { key: "men_power", name: "Men Power", bg: "#f5e6ea" },
    { key: "multi_v", name: "Multi-V", bg: "#fef0e0" },
    { key: "c_mix", name: "C+Mix", bg: "#fdf8d8" },
    { key: "antioxidant", name: "Antioxidant", bg: "#e0f4f7" },
  ];

  function render() {
    var progressHtml = "";
    for (var i = 0; i < totalSteps; i++) {
      progressHtml +=
        '<div class="sq__progress-segment' +
        (i <= current ? " filled" : "") +
        '"></div>';
    }

    var stepsHtml = "";
    questions.forEach(function (q, idx) {
      var optsHtml = "";
      q.opts.forEach(function (o, oi) {
        var sel = answers[idx] === oi ? " selected" : "";
        optsHtml +=
          '<div class="sq__opt' +
          sel +
          '" data-q="' +
          idx +
          '" data-o="' +
          oi +
          '">' +
          '<span class="sq__opt-emoji">' +
          o.emoji +
          "</span>" +
          "<span>" +
          o.text +
          "</span>" +
          "</div>";
      });
      var isLast = idx === totalSteps - 1;
      var navHtml = '<div class="sq__nav">';
      if (idx > 0)
        navHtml +=
          '<button class="sq__btn sq__btn--back" data-go="' +
          (idx - 1) +
          '">Geri</button>';
      navHtml +=
        '<button class="sq__btn sq__btn--next" data-go="' +
        (idx + 1) +
        '"' +
        (answers[idx] === undefined ? " disabled" : "") +
        ">" +
        (isLast ? "Sonucu Gör" : "Devam") +
        "</button>";
      navHtml += "</div>";

      stepsHtml +=
        '<div class="sq__step' +
        (idx === current ? " active" : "") +
        '">' +
        '<p class="sq__step-counter">Soru ' +
        (idx + 1) +
        " / " +
        totalSteps +
        "</p>" +
        '<h3 class="sq__q">' +
        q.q +
        "</h3>" +
        '<div class="sq__opts">' +
        optsHtml +
        "</div>" +
        navHtml +
        "</div>";
    });

    wrap.innerHTML =
      '<div class="sq__header">' +
      '<h1 class="sq__title">Sen Hangi SAOL\'sun?</h1>' +
      '<p class="sq__sub">5 soruda sana en uygun SAOL Vitamin Water\'ı bulalım.</p>' +
      '<div class="sq__progress-bar">' +
      progressHtml +
      "</div>" +
      "</div>" +
      '<div class="sq__step-wrap">' +
      stepsHtml +
      "</div>";

    wrap.querySelectorAll(".sq__opt").forEach(function (el) {
      el.addEventListener("click", function () {
        var qi = parseInt(this.dataset.q);
        var oi = parseInt(this.dataset.o);
        answers[qi] = oi;
        var step = this.closest(".sq__step");
        step.querySelectorAll(".sq__opt").forEach(function (o) {
          o.classList.remove("selected");
        });
        this.classList.add("selected");
        var nextBtn = step.querySelector(".sq__btn--next");
        if (nextBtn) nextBtn.removeAttribute("disabled");
      });
    });
    wrap.querySelectorAll(".sq__btn").forEach(function (el) {
      el.addEventListener("click", function () {
        var go = parseInt(this.dataset.go);
        if (go >= totalSteps) {
          showResult();
          return;
        }
        current = go;
        render();
        wrap.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function getAssetUrl(filename) {
    if (window.saolQuizAssets && window.saolQuizAssets[filename]) {
      return window.saolQuizAssets[filename];
    }
    var link = document.querySelector('link[href*="saol-quiz.css"]');
    if (link) {
      return link.href.replace(/saol-quiz\.css.*/, "") + filename;
    }
    return filename;
  }

  function showResult() {
    scores = {
      women_fit: 0,
      men_power: 0,
      multi_v: 0,
      c_mix: 0,
      antioxidant: 0,
    };
    questions.forEach(function (q, qi) {
      var oi = answers[qi];
      if (oi === undefined) return;
      var map = q.opts[oi].map;
      for (var k in map) scores[k] += map[k];
    });
    var winner = Object.keys(scores).reduce(function (a, b) {
      return scores[a] >= scores[b] ? a : b;
    });
    var r = results[winner];
    var bodyHtml = r.body.replace(/\n/g, "<br>");
    var checksHtml = r.checks
      .map(function (c) {
        return "<li>" + c + "</li>";
      })
      .join("");

    var genderAnswer = answers[0]; // 0 = Kadın, 1 = Erkek
    var othersHtml = "";
    otherCards.forEach(function (card) {
      if (card.key === winner) return;
      // Kadın ise men_power gösterme
      if (genderAnswer === 0 && card.key === "men_power") return;
      // Erkek ise women_fit gösterme
      if (genderAnswer === 1 && card.key === "women_fit") return;
      var cr = results[card.key];
      othersHtml +=
        '<a href="/products/' +
        cr.handle +
        '" class="sq__other-card" style="background:' +
        card.bg +
        '">' +
        '<span class="sq__other-card-emoji">' +
        card.emoji +
        "</span>" +
        '<span class="sq__other-card-name">' +
        card.name +
        "</span>" +
        '<span class="sq__other-card-btn">Keşfet</span>' +
        "</a>";
    });

    var imgUrl = getAssetUrl(r.image);

    var otherCardsWithImages = "";
    otherCards.forEach(function (card) {
      if (card.key === winner) return;
      // Kadın ise men_power gösterme
      if (genderAnswer === 0 && card.key === "men_power") return;
      // Erkek ise women_fit gösterme
      if (genderAnswer === 1 && card.key === "women_fit") return;
      var cr = results[card.key];
      var cardImg = getAssetUrl(cr.image);
      otherCardsWithImages +=
        '<a href="/products/' +
        cr.handle +
        '" class="sq__other-card" style="background:' +
        card.bg +
        '">' +
        '<img src="' +
        cardImg +
        '" alt="SAOL ' +
        card.name +
        '" class="sq__other-card-img" loading="lazy">' +
        '<span class="sq__other-card-name">' +
        card.name +
        "</span>" +
        '<span class="sq__other-card-btn">Keşfet</span>' +
        "</a>";
    });

    wrap.innerHTML =
      '<div class="sq__result-page">' +
      '<div class="sq__result-hero" style="background:' +
      r.bg +
      '">' +
      '<div class="sq__result-hero-inner">' +
      '<div class="sq__result-image">' +
      '<img src="' +
      imgUrl +
      '" alt="SAOL ' +
      r.name +
      '" loading="eager">' +
      "</div>" +
      '<div class="sq__result-text">' +
      '<div class="sq__result-icon">' +
      r.emoji +
      "</div>" +
      '<h2 class="sq__result-name">' +
      r.name +
      "</h2>" +
      '<p class="sq__result-need">' +
      r.need +
      "</p>" +
      '<div class="sq__result-body">' +
      bodyHtml +
      "</div>" +
      '<ul class="sq__result-checks">' +
      checksHtml +
      "</ul>" +
      '<p class="sq__result-quote">' +
      r.quote +
      "</p>" +
      '<a href="/products/' +
      r.handle +
      '" class="sq__result-cta">Sepete Ekle</a>' +
      '<div class="sq__email sq__email--inline">' +
      '<h3 class="sq__email-title">Sana özel öneriler ister misin?</h3>' +
      '<p class="sq__email-sub">Hangi ürünü ne zaman içmen gerektiğini gönderelim.</p>' +
      '<form class="sq__email-form" onsubmit="return handleQuizEmail(event)">' +
      '<input type="email" placeholder="E-posta adresin" required>' +
      '<button type="submit">Gönder</button>' +
      "</form>" +
      "</div>" +
      "</div>" +
      "</div>" +
      "</div>" +
      '<div class="sq__other-products">' +
      '<h3 class="sq__other-title">Diğer SAOL Aromaları</h3>' +
      '<p class="sq__other-sub">Farklı ihtiyaçların için diğer seçenekleri keşfet.</p>' +
      '<div class="sq__other-grid">' +
      otherCardsWithImages +
      "</div>" +
      "</div>" +
      '<div class="sq__result-bottom">' +
      '<button class="sq__restart" onclick="location.reload()">Testi Tekrarla</button>' +
      "</div>" +
      "</div>";

    wrap.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  render();
});

function handleQuizEmail(e) {
  e.preventDefault();
  var input = e.target.querySelector("input");
  var btn = e.target.querySelector("button");
  btn.textContent = "Gönderildi";
  btn.disabled = true;
  input.disabled = true;
  return false;
}
